export default __webpack_public_path__ + "static/media/music_popup_three.ec022608.png";